import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosComparativasuanominaListaItem {
  data
  totalCoincide = ''
  suaExiste = ''
  nominaExiste = ''

  $onChanges (changes) {
    if (changes.data) {
      this.suaExiste = this.data.suaExiste
        ? 'Se encontró el registro del pago SUA'
        : 'No se encontró el registro del pago SUA'
      this.nominaExiste = this.data.nominaExiste
        ? 'Se encontró un pago de nómina registrado en este período'
        : 'No se encontró un pago de nómina registrado en este período'
      this.totalCoincide = this.data.totalCoincide
        ? 'El total del pago SUA coincide con lo que el colaborador remuneró en el período'
        : 'El total del pago SUA no coincide con lo que el colaborador remuneró en el período'
    }
  }
}

module.component('recursoshumanosComparativasuanominaListaItem', {
  controller: RecursoshumanosComparativasuanominaListaItem,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/comparativaSuaNomina/lista/item/component.js